let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("89WyM"), load("fZt2F"), load("e2ujj"), load("cUtrS")]).then(() => parcelRequire('bzo9I'));